import { useFamilySwitchScreen } from '../family/useFamilySwitchScreen';
export const ActionSelectUser: string = 'actionSelectUser';

export const useActionSelectUser = () => {
  const { onPlay, complete } = useAbstractAction(
    ActionSelectUser,
    true,
    -1,
    []
  );

  const { needToShowScreen } = useFamilySwitchScreen();

  const route = useRoute();

  onPlay(async () => {
    try {
      if (needToShowScreen.value) {
        navigateTo(`/utilisateurs?continue=${route.fullPath}`);
      } else {
        complete(true);
      }
    } catch (e) {
      complete(false);
    }
  });
};
